import Vue from 'vue'
import VeeValidate from 'vee-validate'
import dictionary from './dictionary'
import i18n from '../i18n'

const itMessages = dictionary.it
const enMessages = dictionary.en

Vue.use(VeeValidate, {
  i18nRootKey: 'validations', // customize the root path for validation messages.
  i18n,
  dictionary: {
    it: itMessages,
    en: enMessages
  }
})
